import { render, staticRenderFns } from "./photo-wall.vue?vue&type=template&id=0e15a5b6&scoped=true&"
import script from "./photo-wall.vue?vue&type=script&lang=js&"
export * from "./photo-wall.vue?vue&type=script&lang=js&"
import style0 from "./photo-wall.vue?vue&type=style&index=0&id=0e15a5b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e15a5b6",
  null
  
)

export default component.exports